import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import WOW from 'wowjs';  
import 'animate.css/animate.min.css';  

const initWow = () => {  
    new WOW.WOW({  
        live: false  
    }).init();  
};  

window.onload = initWow;



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


